export default __webpack_public_path__ + "static/media/basic-pin-large-14.6f043dcd.png";